import { cn } from "@omni/utils/styles";

import { useImageGalleryContext } from "@/components/ImageGallery/context/imageGallery.context";

type Props = {
    className?: string;
};

export const PreviousButton = ({ className }: Props) => {
    const { images, activeIndex, previous } = useImageGalleryContext();

    if (images.length <= 1) return null;

    const disabled = activeIndex <= 0;

    return (
        <button
            type={"button"}
            className={cn(className, "tw:border-0 tw:bg-transparent")}
            disabled={disabled}
            onClick={previous}
        >
            <i
                className={cn(
                    "las la-angle-left",
                    "tw:text-3xl tw:text-primary",
                    {
                        "tw:opacity-20": disabled
                    }
                )}
            />
        </button>
    );
};
